import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import AdminTournaments from "@/pages/AdminTournaments";
import AdminVesting from "@/pages/AdminVesting";
import AdminAssosPay from "@/pages/AdminAssosPay";
import AdminAssosPayReports from "@/pages/AdminAssosPayReports";
import Redeem from "@/pages/Redeem";
import RedeemStatus from "@/pages/RedeemStatus";
import LinkCallback from "@/pages/LinkCallback";
import Account from "@/pages/Account";
import Signin from "@/pages/Signin";
import SigninSent from "@/pages/SigninSent";
import SigninConsume from "@/pages/SigninConsume";
import { Toaster } from "sonner";
import { ArcEcosystemProvider } from "@/context/ArcEcosystemContext";
import ErrorBoundary from "@/components/ErrorBoundary";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <ArcEcosystemProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/redeem" element={<Redeem />} />
            <Route path="/redeem/:arcReferenceId" element={<RedeemStatus />} />
            <Route path="/account" element={<Account />} />
            <Route path="/link/callback" element={<LinkCallback />} />
            <Route path="/signin" element={<Signin />} />
            <Route path="/signin/sent" element={<SigninSent />} />
            <Route path="/signin/consume" element={<SigninConsume />} />
            <Route path="/admin/tournaments" element={<AdminTournaments />} />
            <Route path="/admin/vesting" element={<AdminVesting />} />
            <Route path="/admin/assospay" element={<AdminAssosPay />} />
            <Route path="/admin/assospay/reports" element={<AdminAssosPayReports />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#0a0b10",
              border: "1px solid rgba(0, 240, 255, 0.3)",
              color: "#fff",
              fontFamily: "JetBrains Mono, monospace",
            },
          }}
        />
        </ArcEcosystemProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
